import { render, staticRenderFns } from "./LedgerModalNanoS.vue?vue&type=template&id=a577e81a&scoped=true"
var script = {}
import style0 from "./LedgerModalNanoS.vue?vue&type=style&index=0&id=a577e81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a577e81a",
  null
  
)

export default component.exports